import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetBooksQuery } from "../../../features/Api/ApiSlice";
import {
    featuedAll,
    featuedFilter
} from "../../../features/Filter/FilterSlice";
import Book from "../../Book/Book";

const Books = () => {
  const { data: books, isLoading, isError } = useGetBooksQuery();
  const dispatch = useDispatch();
  const filter = useSelector((state) => state.filter);

  const filterByFeatured = () => {
    return (book) => (filter?.featured ? book.featured : book);
  };

  const searchFilter = () => {
    return (book => filter?.searchText ? book.name.toLowerCase().includes(filter?.searchText.toLowerCase()):book)
  }

  // decide what to render
  let content = null;

  if (isLoading) {
    content = <h2>Loading...</h2>;
  }

  if (!isLoading && isError) {
    content = <h2>Something wents wrong.</h2>;
  }

  if (!isLoading && !isError && books?.length === 0) {
    content = <h2>Something wents wrong.</h2>;
  }

  if (!isLoading && !isError && books?.length > 0) {
    content = books
    .filter(searchFilter())
      .filter(filterByFeatured())
      .map((book) => <Book key={book.id} book={book}></Book>);
  }
  return (
    <main class="py-12 px-6 2xl:px-6 container">
      <div class="order-2 xl:-order-1">
        <div class="flex items-center justify-between mb-12">
          <h4 class="mt-2 text-xl font-bold">Book List</h4>

          <div class="flex items-center space-x-4">
            <button
              onClick={() => dispatch(featuedAll())}
              class={`lws-filter-btn ${!filter?.featured && "active-filter"}`}
            >
              All
            </button>
            <button
              onClick={() => dispatch(featuedFilter())}
              class={`lws-filter-btn ${filter?.featured && "active-filter"}`}
            >
              Featured
            </button>
          </div>
        </div>
        <div class="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* <!-- Card 1 --> */}
          {content}
        </div>
      </div>
    </main>
  );
};

export default Books;
